module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="popup"></span>\n<button class="email-btn send-test btn btn-grey">Send Test Email</button>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/email/SendTestEmailButtonView.tpl
// module id = 2923
// module chunks = 0